import { PlusSVG } from '@sbercloud/uikit-product-icons';
import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { FieldStepper } from '@snack-uikit/fields';
import { Typography } from '@snack-uikit/typography';
import { useCalculatorContext, useProductContext } from '../../contexts';
import { PRICE_PERIOD } from '../../types';
import { parseKeyToDataTest } from '../../utils';
import { HeaderContainer } from '../HeaderContainer';
import { PriceSummary, SummaryAppearance } from '../PriceSummary';
import { PriceCount } from '../ProductHeadline/components';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var WELCOME_STEPS = ['Нажмите Добавить сервис', 'Выберите платформу и продукт', 'Настройте конфигурацию', 'Подключите сразу или оставьте заявку'];
export function Welcome(_ref) {
  var image = _ref.image;
  var _useCalculatorContext = useCalculatorContext(),
    setCatalogOpen = _useCalculatorContext.setCatalogOpen,
    onStartClick = _useCalculatorContext.actions.onStartClick;
  var _useProductContext = useProductContext(),
    price = _useProductContext.price;
  var handleCatalogOpen = function handleCatalogOpen() {
    onStartClick === null || onStartClick === void 0 ? void 0 : onStartClick();
    setCatalogOpen(true);
  };
  var _useCalculatorContext2 = useCalculatorContext(),
    layoutType = _useCalculatorContext2.layoutType;
  var isTablet = layoutType !== LAYOUT_TYPE.Desktop && layoutType !== LAYOUT_TYPE.DesktopSmall;
  var isDesctopSmall = layoutType === LAYOUT_TYPE.DesktopSmall;
  var isMobile = layoutType === LAYOUT_TYPE.Mobile;
  var TitleComponent = isTablet ? Typography.SansTitleL : Typography.SansHeadlineS;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": parseKeyToDataTest('welcome'),
    className: styles.wrapper,
    "data-desktop-small": isDesctopSmall || undefined,
    "data-tablet": isTablet || undefined,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.configurator,
      "data-test-id": parseKeyToDataTest('welcome', 'configurator'),
      "data-desktop-small": isDesctopSmall || undefined,
      "data-tablet": isTablet || undefined,
      children: [/*#__PURE__*/_jsxs(HeaderContainer, {
        dataTestId: parseKeyToDataTest('welcome', 'header'),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.left,
          children: /*#__PURE__*/_jsx(TitleComponent, {
            "data-test-id": parseKeyToDataTest('product', 'title'),
            children: "\u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.right,
          "data-tablet": isTablet || undefined,
          children: [/*#__PURE__*/_jsx(PriceCount, {
            price: price,
            pricePeriod: PRICE_PERIOD.Month,
            mobile: isMobile
          }), /*#__PURE__*/_jsx("div", {
            className: styles.counter,
            "data-test-id": parseKeyToDataTest('product', 'counter'),
            children: /*#__PURE__*/_jsx(FieldStepper, {
              size: "m",
              step: 1,
              min: 1,
              max: 1,
              value: 1,
              disabled: true,
              allowMoreThanLimits: false
            })
          }), !isTablet && /*#__PURE__*/_jsx(ButtonFilled, {
            fullWidth: isTablet,
            label: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
            size: "m",
            appearance: "primary",
            onClick: function onClick() {},
            disabled: true
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.body,
        "data-mobile": isMobile || undefined,
        "data-tablet": isTablet || undefined,
        "data-test-id": parseKeyToDataTest('welcome', 'body'),
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.headings,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.headingsText,
            children: [/*#__PURE__*/_jsx(Typography.SansTitleL, {
              "data-test-id": parseKeyToDataTest('welcome', 'title'),
              children: "\u0423\u0437\u043D\u0430\u0439\u0442\u0435, \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u0434\u0435\u0442 \u0441\u0442\u043E\u0438\u0442\u044C \u043E\u0431\u043B\u0430\u043A\u043E"
            }), /*#__PURE__*/_jsxs(Typography.SansBodyM, {
              className: styles.desc,
              "data-test-id": parseKeyToDataTest('welcome', 'desc'),
              children: ["\u0421\u043E\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043E\u044E \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044E \u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432, \u0443\u0437\u043D\u0430\u0439\u0442\u0435 \u0435\u0435 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C", /*#__PURE__*/_jsx("br", {}), "\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435. \u041A\u0430\u043B\u044C\u043A\u0443\u043B\u044F\u0442\u043E\u0440 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0438\u0442 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0435", /*#__PURE__*/_jsx("br", {}), "\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0434\u043B\u044F \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u0438 \u043D\u0430 \u0441\u0442\u0430\u0440\u0442\u0435"]
            })]
          }), (isTablet || isDesctopSmall) && /*#__PURE__*/_jsx(ButtonFilled, {
            onClick: handleCatalogOpen,
            size: "m",
            icon: /*#__PURE__*/_jsx(PlusSVG, {}),
            label: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0435\u0440\u0432\u0438\u0441",
            appearance: "primary",
            "data-test-id": parseKeyToDataTest('welcome', 'button')
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.steps,
          "data-test-id": parseKeyToDataTest('welcome', 'steps'),
          children: WELCOME_STEPS.map(function (item, index) {
            return /*#__PURE__*/_jsxs("div", {
              className: styles.step,
              "data-test-id": parseKeyToDataTest('welcome', 'step'),
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.number,
                children: /*#__PURE__*/_jsx(Typography.SansLabelL, {
                  children: index + 1
                })
              }), /*#__PURE__*/_jsx(Typography.SansTitleS, {
                children: item
              })]
            }, index);
          })
        }), image && /*#__PURE__*/_jsx("img", {
          className: styles.image,
          src: image,
          alt: "calculator",
          "data-test-id": parseKeyToDataTest('welcome', 'image'),
          "data-mobile": isMobile || undefined,
          "data-tablet": isTablet || undefined
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.priceSummary,
      "data-desktop-small": isDesctopSmall || undefined,
      "data-tablet": isTablet || undefined,
      "data-test-id": parseKeyToDataTest('welcome', 'summary'),
      children: /*#__PURE__*/_jsx(PriceSummary, {
        appearance: SummaryAppearance.Welcome
      })
    })]
  });
}